import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fade: false,
    };
  }

  componentDidMount() {
    // will fade modal in when mounted
    this.timeout = setTimeout(() => {
      this.setState({ fade: true })
    }, 200)
  }

  componentDidUpdate(prevProps) {
    const { toggleModal, fadeModalOut } = this.props;
    // On Modal close, fade out container before destroyed.
    // Receives fadeModalOut props from modal controlling button
    if (prevProps.fadeModalOut !== fadeModalOut) {
      this.setState({ fade: false })
      toggleModal()
    }
  }

  render() {
    const { domQuery, toggleModal } = this.props;
    // Common Modal component adds modal to domQuery element passed from modal controlling button
    return ReactDOM.createPortal(
      <div className={`modal__container ${this.state.fade ? 'modal__container-fade-in' : 'modal__container-fade-out'}`}>
        <div className="modal__overlay " onClick={toggleModal} />
        {this.props.children}
      </div>,
      document.querySelector(domQuery)
    );
  }
}

export default (Modal);



// WEBPACK FOOTER //
// ./src/features/agent-info-verification/common/Modal.js